'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../../styleInject.js');

var css_248z = ".Markdown-module_p__lbkDk{margin:0}.Markdown-module_p__lbkDk+.Markdown-module_p__lbkDk{margin-top:.5rem}";
var styles = {"p":"Markdown-module_p__lbkDk"};
styleInject["default"](css_248z, '9afd2ce5-457e-49cd-a29a-6ad55b602e10');

exports["default"] = styles;
